import React from 'react';
import { motion } from 'framer-motion';
import { SlideLayout } from '../SlideLayout';
import { BookOpen } from 'lucide-react';
const sources = [{
  id: 1,
  text: "Nvidia Isn't Competing In The Market. It's Shaping It — But For How Long?",
  pub: 'Forbes',
  url: 'https://www.forbes.com/sites/renanaashkenazi/2026/02/25/nvidia-isnt-competing-in-the-market-its-shaping-it---but-for-how-long/'
}, {
  id: 2,
  text: 'AI Accelerator Market Looks Set to Exceed $600 Billion by 2033',
  pub: 'Bloomberg Intelligence',
  url: 'https://www.bloomberg.com/company/press/ai-accelerator-market-looks-set-to-exceed-600-billion-by-2033-driven-by-hyperscale-spending-and-asic-adoption-according-to-bloomberg-intelligence/'
}, {
  id: 3,
  text: 'Artificial Intelligence (AI) Chipsets Market Size to Hit USD 931.26B',
  pub: 'Precedence Research',
  url: 'https://www.precedenceresearch.com/artificial-intelligence-chipsets-market'
}, {
  id: 4,
  text: 'AI Chips In Consumer Electronics — Statistics & Market Data',
  pub: 'SQ Magazine',
  url: 'https://sqmagazine.co.uk/ai-chip-statistics/'
}, {
  id: 5,
  text: 'AI Chips Market Size to Hit Around USD 771.74 Billion by 2035',
  pub: 'Cervicorn Consulting',
  url: 'https://www.cervicornconsulting.com/artificial-intelligence-chips-market'
}, {
  id: 6,
  text: 'Google TPUv7: The 900lb Gorilla In the Room',
  pub: 'SemiAnalysis',
  url: 'https://newsletter.semianalysis.com/p/tpuv7-google-takes-a-swing-at-the'
}, {
  id: 7,
  text: 'GPU, TPU, and ASIC Competition in Inference Chips',
  pub: 'Guru Startups',
  url: 'https://www.gurustartups.com/reports/gpu-tpu-and-asic-competition-in-inference-chips'
}, {
  id: 8,
  text: 'Nvidia Blackwell, Google TPUs, AWS Trainium: Comparing Top AI Chips',
  pub: 'CNBC',
  url: 'https://www.cnbc.com/2025/11/21/nvidia-gpus-google-tpus-aws-trainium-comparing-the-top-ai-chips.html'
}, {
  id: 9,
  text: 'Nvidia Posts Record $68.1B Quarter as AI Boom Accelerates',
  pub: 'TechBuzz AI',
  url: 'https://www.techbuzz.ai/articles/nvidia-posts-record-68-1b-quarter-as-ai-boom-accelerates'
}, {
  id: 10,
  text: 'AI Chip Market Size, Share, Industry Report, 2025-2032',
  pub: 'MarketsAndMarkets',
  url: 'https://www.marketsandmarkets.com/Market-Reports/artificial-intelligence-chipset-market-237558655.html'
}, {
  id: 11,
  text: 'Nvidia Market Share AI Accelerators 2025: The Future of Computing',
  pub: 'Reelmind',
  url: 'https://reelmind.ai/blog/nvidia-market-share-ai-accelerators-2025-the-future-of-computing'
}, {
  id: 12,
  text: 'AI Inference Market — Market Segments',
  pub: 'MarketsAndMarkets',
  url: 'https://www.marketsandmarkets.com/Market-Reports/ai-inference-market-189921964.html'
}, {
  id: 13,
  text: 'Nvidia Market Share AI Accelerators 2025: Industry Insights',
  pub: 'Reelmind',
  url: 'https://reelmind.ai/blog/nvidia-market-share-ai-accelerators-2025-industry-insights'
}, {
  id: 14,
  text: 'AI Inference GPU Report 2025',
  pub: 'Market Report Analytics',
  url: 'https://www.marketreportanalytics.com/reports/ai-inference-gpu-386895'
}, {
  id: 15,
  text: 'Global AI Chip Market Size 2026-2036',
  pub: 'Meticulous Research',
  url: 'https://www.meticulousresearch.com/product/ai-chip-market-6444'
}, {
  id: 16,
  text: 'High-performance AI Inference Chip Market',
  pub: 'Market Report Analytics',
  url: 'https://www.marketreportanalytics.com/reports/high-performance-ai-inference-chip-377503'
}, {
  id: 17,
  text: 'Startup Takes on Nvidia with FPGA-based AI',
  pub: 'EE Times Asia',
  url: 'https://www.eetasia.com/startup-takes-on-nvidia-with-fpga-based-ai/'
}, {
  id: 18,
  text: 'Energy Use of AI Inference: Efficiency Pathways',
  pub: 'arXiv',
  url: 'https://arxiv.org/pdf/2509.20241.pdf'
}, {
  id: 19,
  text: 'LoopLynx: Scalable Dataflow Architecture for LLM Inference on FPGA',
  pub: 'Quantum Zeitgeist',
  url: 'https://quantumzeitgeist.com/looplynx-scalable-dataflow-architecture-for-high-speed-llm-inference-on-fpga/'
}, {
  id: 20,
  text: 'Prefill-Decode Disaggregation — LLM Inference Handbook',
  pub: 'BentoML',
  url: 'https://bentoml.com/llm/inference-optimization/prefill-decode-disaggregation'
}, {
  id: 21,
  text: 'Mastering LLM Techniques: Inference Optimization',
  pub: 'NVIDIA Developer Blog',
  url: 'https://developer.nvidia.com/blog/mastering-llm-techniques-inference-optimization/'
}, {
  id: 22,
  text: 'FPGA-based Spatial Acceleration for LLMs',
  pub: 'ACM Digital Library',
  url: 'https://dl.acm.org/doi/full/10.1145/3656177'
}, {
  id: 23,
  text: 'FPGA vs GPU — Is This the End of FPGA?',
  pub: 'Gidel',
  url: 'https://gidel.com/fpga-vs-gpu-interview/'
}];
export function SourcesPage1Slide() {
  const half = Math.ceil(sources.length / 2);
  const col1 = sources.slice(0, half);
  const col2 = sources.slice(half);
  return <SlideLayout slideNumber={19} totalSlides={20} title="References (1/2)" data-id="element-454">
      <div className="max-w-7xl mx-auto w-full" data-id="element-455">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="flex items-center justify-center gap-3 mb-6" data-id="element-456">
          <BookOpen size={24} className="text-brand-primary" data-id="element-457" />
          <h2 className="text-3xl font-bold" data-id="element-458">Sources & References</h2>
        </motion.div>

        <div className="flex items-center justify-center gap-6 mb-6" data-id="element-459">
          <div className="flex items-center gap-2" data-id="element-460">
            <div className="w-3 h-3 rounded-full bg-chip-tpu" data-id="element-461" />
            <span className="text-brand-muted" data-id="element-462">Market Data [1–16]</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-463">
            <div className="w-3 h-3 rounded-full bg-brand-primary" data-id="element-464" />
            <span className="text-brand-muted" data-id="element-465">Technical [17–45]</span>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.2
      }} className="grid grid-cols-1 md:grid-cols-2 gap-x-8" data-id="element-466">
          {[col1, col2].map((col, colIdx) => <div key={colIdx} className="space-y-1" data-id="element-467">
              {col.map(source => <a key={source.id} href={source.url} target="_blank" rel="noopener noreferrer" className="flex gap-3 py-2 border-b border-brand-border/20 last:border-0 hover:bg-brand-primary/5 rounded px-2 -mx-2 transition-colors cursor-pointer group" data-id="element-468">
                  <span className={`font-mono font-bold shrink-0 pt-0.5 ${source.id <= 16 ? 'text-chip-tpu' : 'text-brand-primary'}`} data-id="element-469">
                    [{source.id}]
                  </span>
                  <span className="text-white group-hover:text-brand-primary transition-colors" data-id="element-470">
                    {source.text}{' '}
                    <span className="text-brand-muted" data-id="element-471">— {source.pub}</span>
                  </span>
                </a>)}
            </div>)}
        </motion.div>
      </div>
    </SlideLayout>;
}